import "./Switch.css";

type Props = {
  checked: boolean;
  id: string
  onColor?: string
  onChange: (checked: boolean) => void;
};

export default function Switch(props: Props) {
  const { checked, onChange, id, onColor } = props;
  const bgcolor = checked ? (onColor ?? "#35c659") : "#e9e9ea"
  return (
    <>
      <input
        id={id}
        type="checkbox"
        className="switch_input"
        checked={checked}
        onChange={() => {
          onChange(!checked);
        }}
        style={{backgroundColor: bgcolor}}
      />
      <label htmlFor={id} className="switch_label" style={{backgroundColor: bgcolor}}></label>
    </>
  );
}
